import { createGenericColumn } from '../../../utils/table-headers-utils';

export const ShareWithUsersColumns = [
  {
    ...createGenericColumn('UserId'),
    width: '75%',
  },
];
